import { useState, useCallback } from 'react';
import { sendContactForm } from '../services/contactApi';

export function useContact() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitContact = useCallback(async (formData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await sendContactForm(formData);
      return response;
    } catch (err) {
      setError(err.message || 'Erreur lors de l\'envoi du message');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, submitContact };
}

export default useContact;